/** In-game HP bar displayed in the top-left corner. */
export function HpBar({ hp, maxHp }) {
  const pct  = Math.min(100, Math.max(0, (hp / maxHp) * 100));
  const color = pct > 60 ? '#52e084' : pct > 30 ? '#e0c052' : '#e05252';
  return (
    <div className="hp-bar-wrap">
      <div className="hp-bar-track">
        <div className="hp-bar-fill" style={{ width: `${pct}%`, background: color }} />
      </div>
      <span className="hp-bar-label">❤️ {Math.max(0, hp)} / {maxHp}</span>
    </div>
  );
}
